import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';

const reservations = [
  { id: 1, amenity: 'Salón de Eventos', time: '14:00 - 18:00', user: 'Torre A - 302', status: 'confirmed' },
  { id: 2, amenity: 'Piscina', time: '10:00 - 12:00', user: 'Torre B - 105', status: 'confirmed' },
  { id: 3, amenity: 'Gimnasio', time: '18:00 - 19:00', user: 'Torre A - 501', status: 'pending' },
];

export function AmenitiesWidget() {
  const navigate = useNavigate();

  return (
    <div className="space-y-3">
      {reservations.map((res) => (
        <div key={res.id} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
          <div className={`w-2 h-2 rounded-full ${
            res.status === 'confirmed' ? 'bg-green-500' : 'bg-yellow-500'
          }`} />
          <div className="flex-1 min-w-0">
            <p className="font-medium text-gray-900 text-sm truncate">{res.amenity}</p>
            <div className="flex items-center gap-2 text-xs text-gray-500 mt-1">
              <Clock className="w-3 h-3" />
              <span>{res.time}</span>
            </div>
          </div>
          <div className="text-right">
            <p className="text-xs text-gray-500">{res.user}</p>
          </div>
        </div>
      ))}

      <div className="pt-2 border-t border-gray-100">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-500">Próximas 24h:</span>
          <span className="font-semibold text-[#36CCD8]">8 reservas</span>
        </div>
      </div>

      <button
        onClick={() => navigate('/amenities')}
        className="w-full py-2 text-sm font-medium text-[#36CCD8] hover:text-[#2DB8C4] hover:bg-[#36CCD8]/5 rounded-lg transition-colors"
      >
        Gestionar amenidades →
      </button>
    </div>
  );
}

export default AmenitiesWidget;
